module.exports = "/_next/static/images/d7d4130bf289659b5a11cb9134983406-woman-with-iphone@2x.jpg.webp";